<template>
  <div class="vd__menu_nav">
    <div class="vd__menu_logo"></div>
    <div class="vd__menu_items">
      <div class="vd__menu_item" :class="{ 'active': location === item.path }"
           v-for="item in menu"
           :key="item.name"
           v-show="item.menu">
        <router-link :to="item.path">{{ $t(item.label) }}
          <span v-if="newAt(item)" class="badge-new">{{ $t('words.new') }}</span>
        </router-link>
      </div>
      <div class="vd__menu_item" id="feedback" @click="openAnnouncements">
        <a href="javascript:void(0)">
          {{ $t('menu.changelog') }}
        </a>
      </div>
    </div>
    <div class="vd__menu_account">
      <div class="vd__monitor_button">
        <a class="ant-dropdown-link monitorbubble" @click="$monitor.open()">
          <span style="margin-right: 7px;">{{ $t('menu.live-monitor') }}</span>
          <a-badge
            :count="monitorConnected ? 0 : 1"
            dot
            :number-style="{ background: monitorConnected ? '#10b981' : '#6b7280' }"
          />
          <a-icon type="desktop" />
        </a>
      </div>
      <div class="vd__help_button">
        <a class="ant-dropdown-link helpbubble" @click="() => openModal('knowledge-base')">
                  <span
                    style="margin-right: 7px;"
                  >
                    {{ $t('words.helpCenter') }}
                  </span>
          <a-icon type="read"/>
        </a>
      </div>
      <div class="vd__menu_dropdown_account">
        <a-dropdown style="display: flex;">
          <a class="ant-dropdown-link vd__menu_account_text">
            <div class="vd__account_username">
              <div class="vd__account-name">{{ name }}</div>
              <div class="vd__account-email">{{ $store.getters['global/email'] }}</div>
            </div>
            <a-icon type="down"/>
          </a>
          <a-menu slot="overlay" class="vd__dropdown_account">
            <a-menu-item
              v-for="item in account"
              :key="item.name"
              v-show="verifyRender(item)"
              @click="() => 'action' in item ? customAction(item) : goToPage(item.name)">
              <a href="javascript:;">{{ $t(item.label) }}</a>
            </a-menu-item>
            <a-menu-divider/>
            <a-menu-item @click="logout">
              <a href="javascript:;">
                {{ $t('menu.account.logout') }}
              </a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
    <a-drawer
      class="helpercenter-drawer"
      :title="`${$t('words.helpCenter')} 🧠`"
      placement="right"
      :closable="true"
      :visible="helpcenter"
      @close="helpcenter = false"
      :mask="false"
    >
      <div class="iframe-container">
        <iframe :src="helpcenterSrc" ref="knowledge-base-iframe"></iframe>
      </div>
    </a-drawer>
    <ModelHelp :height="heightChangelogs"
               :title="`${$t('words.changelog')} 🤓`"
               ref="changelogs"
               :x="105"
               :y="40"
               @refresh="() => refreshIframe('changelogs')"
    >
      <div class="iframe-container" id="changelogs-modal"></div>
    </ModelHelp>
  </div>
</template>

<script>
import HumanizeDate from '@/plugins/humanize.date.js';

export default {
  data: () => ({
    notifications: 0,
    changelogs: 0,
    heightChangelogs: 270,
    liveMonitor: false,
    segmentsQueue: [],
    monitor: null,
    timestamp: null,
    latestUpdate: null,
    helpcenter: false,
    helpcenterSrc: 'https://docs.videsk.io/v/es-dashboard',
  }),
  mounted() {
    // this.createLiveMonitorInstance();
    document.addEventListener('helpcenter', event => {
      const {
        status = false,
        src
      } = event.detail;
      this.helpcenter = status;
      if (src) this.helpcenterSrc = src;
    });
  },
  computed: {
    menu() {
      return this.$router.options.routes[0].children;
    },
    account() {
      const menu = this.$router.options.routes[0].children.find(item => item.name === 'account');
      return menu.children;
    },
    location() {
      return window.location.pathname;
    },
    name() {
      return `${this.$store.getters['global/firstname']} ${this.$store.getters['global/lastname']}`;
    },
    totalInQueue() {
      if (this.segmentsQueue.length === 0) return 0;
      return this.segmentsQueue.reduce((accumulator, segment) => {
        // eslint-disable-next-line no-param-reassign
        accumulator += segment.queues.length;
        return accumulator;
      }, 0);
    },
    launchDate() {
      const now = new Date().getTime();
      return now > 1633316400000;
    },
    features() {
      return this.$store.getters['global/features'];
    },
    monitorConnected() {
      return this.$store.getters['live-monitor/connected'];
    },
  },
  created() {
    setInterval(() => {
      this.updateLatestUpdate();
    }, 10000);
  },
  watch: {
    timestamp() {
      this.updateLatestUpdate();
    },
  },
  methods: {
    openAnnouncements() {
      window.feedbackWidget?.viewSection('announcements');
    },
    customAction(item) {
      const { action } = item;
      if (action === 'feedback') return this.feedback();
    },
    async feedback() {
      window.feedbackWidget.viewSection('ideas');
      window.feedbackWidget.toggle();
    },
    updateLatestUpdate() {
      const dateNow = Date.now();
      const timestamp = new Date(this.timestamp).getTime();
      let ago = 'seconds';
      const difference = (dateNow - timestamp) / 1000;
      if (difference > 60) ago = 'minutes';
      if (difference > 3600) ago = 'hours';
      this.latestUpdate = this.humanizeDate(dateNow, timestamp, ago);
    },
    humanizeDate(date1, date2, ago) {
      return new HumanizeDate().dates(date1, date2)
        .ago(ago);
    },
    async logout() {
      // eslint-disable-next-line max-len
      const refreshToken = window[this.$authorization.storage].getItem(this.$authorization.keys.refreshToken);
      this.$authorization.logout();
      await this.$router.push({ name: 'login' });
      this.$notification.success({ message: this.$t('login.logout') });
      await this.axios.post('/auth/logout', undefined, {
        headers: { Authorization: `Bearer ${refreshToken}` },
      });
      delete this.axios.defaults.headers.common.Authorization;
      window.Frill('unidentify');
    },
    goToPage(pageName) {
      this.$store.dispatch('global/toPage', pageName);
    },
    createLiveMonitorInstance() {
      const accessToken = this.$authorization.getTokens('accessToken');
      this.monitor = new LiveMonitor(accessToken, this.$devOptions.websocket);
      this.monitor.on('queue:updated', (queues = []) => {
        this.timestamp = new Date();
        this.segmentsQueue = queues;
      });
      this.monitor.connect();
    },
    openMonitor() {
      if (!this.$refs['live-monitor']) return;
      if (!this.monitor || (this.monitor && !this.monitor.connection)) this.createLiveMonitorInstance();
      this.liveMonitor = this.$refs['live-monitor'].state;
      this.$refs['live-monitor'].toggle(true);
    },
    openModal(modal) {
      if (modal === 'knowledge-base') {
        if (!(this.helpcenterSrc.includes('dashboard'))) this.helpcenterSrc = 'https://docs.videsk.io/v/es-dashboard';
        return this.helpcenter = true;
      }
      if (this.$refs[modal]) this.$refs[modal].toggle(true);
    },
    refreshIframe(modal) {
      const name = `${modal}-iframe`;
      const changelogs = document.querySelector('#changelogs-modal');
      if (this.$refs[name]) this.$refs[name].src += '';
      if (modal === 'changelogs' && changelogs) changelogs.childNodes[0].src += '';
    },
    newAt(item) {
      const {
        newAt,
        new: isNew
      } = item;
      return isNew && new Date(newAt) > new Date();
    },
    verifyRender(item) {
      const {
        menu,
        feature
      } = item;
      if (!feature && menu) return true;
      if (feature) {
        const response = this.features?.features?.find(feat => feat?.name === feature);
        if (response) return true;
      }
    }
  },
};
</script>

<style>
.vd__menu_nav {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 3%;
  flex-wrap: wrap;
}

.vd__menu_logo {
  width: 45px;
  height: 45px;
  margin-right: 20px;
}

.vd__menu_logo:after {
  content: '';
  width: 100%;
  height: 100%;
  display: block;
  background: url('../assets/img/icon.svg') no-repeat left center / contain;
}

.vd__menu_items {
  width: auto;
  height: 100%;
  flex-grow: 2;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.vd__menu_item {
  width: auto;
  height: 100%;
  font-size: 1em;
  font-weight: 600;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}

.vd__menu_item > a {
  width: max-content;
  height: 100%;
  color: white;
  padding: 5px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.6;
}

.vd__menu_item > a:hover {
  opacity: 1;
}

.vd__menu_item > .router-link-active {
  text-decoration: none;
  opacity: 1;
}

.vd__menu_item:hover {
  opacity: 1;
}

.vd__menu_account {
  width: auto;
  height: 100%;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-left: 10px;
}

.vd__monitor_button {
  margin-right: 10px;
  font-size: 0.9em;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.monitorbubble {
  display: flex;
  justify-content: space-between;
  margin-right: 10px;
  border-right: 1px solid white;
  padding-right: 15px;
  color: white;
  align-items: center;
  gap: 6px;
}

.monitorbubble:hover {
  text-decoration: underline;
  cursor: pointer;
  color: white;
}

.vd__help_button {
  margin-right: 10px;
  font-size: 0.9em;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.vd__menu_account_text, .vd__menu_account_text:hover {
  color: white;
  font-weight: 600;
}

.vd__account_username {
  padding-right: 10px;
  text-transform: capitalize;
}

.vd__account-email {
  font-size: 0.8em;
  font-weight: normal;
  text-transform: none;
}

.vd__dropdown_account {
  transform: translateY(16px) translateX(-13px);
  border-radius: 0 0 4px 4px;
  cursor: pointer;
}

.vd__dropdown_helpbubble {
  transform: translateY(25px) translateX(-60px);
  border-radius: 0 0 4px 4px;
  cursor: pointer;
}

.vd__menu_item.active {
  opacity: 1;
}

.helpbubble {
  display: flex;
  justify-content: space-between;
  margin-right: 10px;
  border-right: 1px solid white;
  padding-right: 15px;
  color: white;
  align-items: center;
}

.helpbubble:hover {
  text-decoration: underline;
  cursor: pointer;
  color: white;
}

.text-left-icon {
  padding-left: 10px;
}

.changelogs {
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: red;
  color: white;
  border-radius: 100%;
  margin-left: 7px;
  font-size: 0.9em;
}

.changelogs[data-count="0"] {
  display: none;
}

.pill-notifications {
  position: relative;
}

.pill-notifications:after {
  content: '';
  background: red;
  width: 7px;
  height: 7px;
  border-radius: 100%;
  position: absolute;
  top: 0;
  right: -5px;
}

.pill-notifications[data-count="0"]:after {
  background: transparent;
}

.iframe-container, .iframe-container iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.helpercenter-drawer .ant-drawer-body {
  padding: 0;
  margin: 0;
  height: calc(100vh - 55px);
}

.helpercenter-drawer .ant-drawer-body, .helpercenter-drawer .ant-drawer-content-wrapper {
  width: 100% !important;
}

.helpercenter-drawer .ant-drawer-wrapper-body {
  overflow: hidden;
}

@media (width <= 500px) {
  .helpercenter-drawer.ant-drawer-open {
    width: 100%;
  }
}

@media (width > 500px) {
  .helpercenter-drawer.ant-drawer-open {
    width: 30vw !important;
  }
}

.live-monitor {
  max-height: 30rem;
  min-height: 7.5rem;
  text-align: left;
}

.live-monitor .help-center-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.live-monitor .top {
  min-height: 4rem;
  border-bottom: 1px solid #e5e7eb;
  font-size: medium;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem 0 1rem;
  background-color: #3778ff;
  color: white;
}

.live-monitor .queue {
  height: 100%;
  max-height: 20rem;
  overflow-y: auto;
  padding: 1rem;
  font-size: medium;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  gap: .5rem;
  border-bottom: 1px solid #e5e7eb;
}

.live-monitor .queue .item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.live-monitor .queue .item span {
  margin-right: 1rem;
}

.live-monitor .queue .item:not(:last-child) {
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #3776ff4d;
}

.live-monitor .bottom {
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
  min-height: 2rem;
  margin-top: auto;
  text-align: end;
}

#monitor-badge {
  margin-left: -.8rem;
}

.badge-new {
  padding: 0px 6px;
  position: absolute;
  top: -5px;
  right: -10px;
  background: red;
  color: white;
  border-radius: 4px;
  font-size: 10px;
}
</style>
